import featherlight from 'featherlight';
export function initFeatherLight() {
	console.log('%cSTART:%c initFeatherLight()', 'color:green', 'color:teal');
	jQuery('.block.video .downloader a, a.resource-video').featherlight();
}
